/* Repo-owned pilot adapter. No identify(), order/customer joins, or dataLayer patch. */
(function (root) {
  'use strict';
  var EVENTS = ['landing_viewed', 'page_viewed', 'product_viewed', 'sample_offer_viewed',
    'sample_cta_clicked', 'calculator_opened', 'calculator_input_started', 'calculator_result',
    'calculator_recommendation_changed', 'calculator_sample_path_selected', 'configured_add_to_cart',
    'product_added_to_cart', 'ui_interacted', 'social_profile_clicked'];
  var ENUMS = {
    page_family: ['index', 'product', 'collection', 'page', 'cart', 'other'],
    product_kind: ['sample', 'roll', 'tool', 'mixed', 'unknown'],
    placement: ['product_calculator', 'product', 'sample_offer'],
    width: ['60', '120'], previous_width: ['60', '120', 'auto'],
    field_category: ['dimensions'], orientation: ['Portrait', 'Landscape', 'portrait', 'landscape'],
    quantity_bucket: ['1', '2-4', '5-9', '10+'], metres_bucket: ['1', '2-4', '5-9', '10+'],
    control: ['calculator', 'sample'], device_class: ['mobile', 'desktop'],
    social_platform: ['facebook', 'instagram'],
    traffic_source: ['google', 'facebook', 'instagram', 'meta', 'direct', 'other'],
    traffic_medium: ['cpc', 'paid_social', 'social', 'organic', 'direct', 'other']
  };
  function bucket(value) {
    var n = Number(value);
    return n > 0 && isFinite(n) ? (n < 2 ? '1' : n < 5 ? '2-4' : n < 10 ? '5-9' : '10+') : undefined;
  }
  // Construct, never spread, incoming payloads. No URLs, config IDs, measurements or free text.
  function clean(name, input, ids) {
    if (EVENTS.indexOf(name) < 0) return null;
    var out = { schema_version: 1, collection_surface: 'storefront', consent_state: 'allowed' };
    input = input || {};
    Object.keys(ENUMS).forEach(function (key) {
      if (ENUMS[key].indexOf(String(input[key])) >= 0) out[key] = String(input[key]);
    });
    if (typeof input.product_handle === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(input.product_handle) && input.product_handle.length < 120) out.product_handle = input.product_handle;
    var source = input.traffic_source;
    // Pattern-only validation: unknown well-formed IDs pass through as-is; data/posthog/ad-id-allowlist.json is a PostHog filter/cohort reference, not enforced matching.
    var paid = source === 'google' || ['facebook', 'instagram', 'meta'].indexOf(source) >= 0;
    ['campaign_id', 'adset_id', 'ad_id'].forEach(function (key) {
      if (paid && /^\d{10,20}$/.test(input[key])) out[key] = input[key];
    });
    return out;
  }
  function attribution(search, ids, referrer) {
    var p;
    try { p = new URLSearchParams(search); } catch (_) { return {}; }
    var source = { google: 'google', facebook: 'facebook', fb: 'facebook', instagram: 'instagram', ig: 'instagram', meta: 'meta', direct: 'direct' }[p.get('utm_source')];
    var medium = { cpc: 'cpc', ppc: 'cpc', paid: 'paid_social', paid_social: 'paid_social', 'paid-social': 'paid_social', social: 'social', organic: 'organic' }[p.get('utm_medium')];
    if (typeof source !== 'string') source = undefined;
    if (typeof medium !== 'string') medium = undefined;
    // Presence only: never read, store or forward a click identifier's value.
    if (!source && p.has('gclid')) { source = 'google'; medium = 'cpc'; }
    if (!source && p.has('fbclid')) { source = 'facebook'; medium = 'social'; }
    var tagged = false;
    p.forEach(function (_, key) { if (/^utm_/i.test(key)) tagged = true; });
    if (!source && !tagged) {
      if (!referrer) { source = 'direct'; medium = 'direct'; }
      else {
        try {
          var url = new URL(referrer), host = url.hostname.toLowerCase();
          if (url.protocol === 'https:' || url.protocol === 'http:') {
            if (/(^|\.)google\.(com|com\.au|co\.uk)$/.test(host)) { source = 'google'; medium = 'organic'; }
            else if (/(^|\.)(bing\.com|duckduckgo\.com)$/.test(host)) { source = 'other'; medium = 'organic'; }
            else if (/(^|\.)(facebook\.com|instagram\.com)$/.test(host)) { source = /(^|\.)instagram\.com$/.test(host) ? 'instagram' : 'facebook'; medium = 'social'; }
          }
        } catch (_) {}
      }
    }
    if (!source) return {};
    if (source === 'direct') medium = 'direct';
    var input = { traffic_source: source, traffic_medium: medium || 'other' };
    input.campaign_id = p.get('campaign_id') || p.get('utm_id') || p.get('utm_campaign');
    input.adset_id = p.get('adset_id') || p.get('utm_adset') || p.get('utm_term');
    input.ad_id = p.get('ad_id') || p.get('utm_content');
    var safe = clean('page_viewed', input, ids), out = {};
    ['traffic_source', 'traffic_medium', 'campaign_id', 'adset_id', 'ad_id'].forEach(function (k) { if (safe[k]) out[k] = safe[k]; });
    return out;
  }
  function pageMetrics(doc, root, allowed) {
    var feed = doc.querySelector && doc.querySelector('.vmcm-feed');
    var scroller = feed || doc.scrollingElement || doc.documentElement;
    var maximum = 0, active = 0, visible = doc.visibilityState !== 'hidden';
    function now() { return root.performance ? root.performance.now() : Date.now(); }
    var since = now();
    function time() {
      var at = now();
      if (allowed() && visible) active = Math.min(86400000, active + Math.max(0, at - since));
      since = at;
    }
    function scroll() {
      if (!allowed() || !scroller) return;
      var range = scroller.scrollHeight - scroller.clientHeight;
      if (range > 0) maximum = Math.max(maximum, Math.min(1, Math.max(0, scroller.scrollTop / range)));
    }
    doc.addEventListener('visibilitychange', function () { time(); visible = doc.visibilityState !== 'hidden'; });
    doc.addEventListener('scroll', function (event) {
      if (event.target === scroller || (!feed && event.target === doc)) scroll();
    }, { capture: true, passive: true });
    scroll();
    return function () {
      time(); scroll();
      var out = { active_seconds: Math.floor(active / 1000), scroll_surface: feed ? 'feed' : 'document' };
      if (scroller) out.scroll_depth_bucket = maximum === 0 && scroller.scrollHeight <= scroller.clientHeight ?
        'not_scrollable' : String(Math.floor((maximum * 100 + 0.001) / 25) * 25);
      return out;
    };
  }
  function nativeProperties(name, input, url) {
    if (['$pageview', '$pageleave', '$$heatmap', '$web_vitals', '$dead_click', '$rageclick'].indexOf(name) < 0) return null;
    input = input || {};
    var out = { $current_url: url, $pathname: url.replace(/^https:\/\/[^/]+/, '') || '/' };
    ['$viewport_width', '$viewport_height', '$screen_width', '$screen_height', '$prev_pageview_duration',
      '$prev_pageview_last_scroll', '$prev_pageview_max_scroll', '$prev_pageview_last_scroll_percentage',
      '$prev_pageview_max_scroll_percentage', '$prev_pageview_last_content', '$prev_pageview_max_content',
      '$prev_pageview_last_content_percentage', '$prev_pageview_max_content_percentage'].forEach(function (k) {
      if (typeof input[k] === 'number' && isFinite(input[k]) && input[k] >= 0 && input[k] < 10000000) out[k] = input[k];
    });
    // Full-document navigation: safely associate end-of-page scroll metrics with this public path.
    if (name === '$pageleave') out.$prev_pageview_pathname = out.$pathname;
    if (name === '$dead_click' || name === '$rageclick') out.interaction_kind = name === '$dead_click' ? 'dead_click' : 'rage_click';
    if (name === '$$heatmap') {
      var points = [];
      Object.keys(input.$heatmap_data || {}).forEach(function (k) {
        var rows = input.$heatmap_data[k];
        if (!Array.isArray(rows)) return;
        rows.forEach(function (p) {
          if (points.length < 100 && p && ['click', 'mousemove', 'rageclick', 'deadclick'].indexOf(p.type) >= 0 &&
              typeof p.x === 'number' && typeof p.y === 'number' && isFinite(p.x) && isFinite(p.y) && p.x >= 0 && p.y >= 0 && p.x < 100000 && p.y < 100000) {
            points.push({ x: p.x, y: p.y, type: p.type, target_fixed: p.target_fixed === true });
          }
        });
      });
      if (!points.length) return null;
      out.$heatmap_data = {}; out.$heatmap_data[url] = points;
    }
    if (name === '$web_vitals') {
      var count = 0;
      ['LCP', 'INP', 'CLS'].forEach(function (metric) {
        var key = '$web_vitals_' + metric + '_value', value = input[key];
        if (typeof value === 'number' && isFinite(value) && value >= 0 && value < 10000000) { out[key] = value; count++; }
      });
      if (!count) return null;
    }
    return out;
  }
  if (typeof module === 'object' && module.exports) { module.exports = { clean: clean, bucket: bucket, attribution: attribution, nativeProperties: nativeProperties, pageMetrics: pageMetrics }; return; }
  var doc = root.document;
  var node = doc.getElementById('velven-posthog-config');
  if (!node || root.VelvenPostHog) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (!/^phc_[A-Za-z0-9]+$/.test(config.key) || config.host !== 'https://eu.i.posthog.com') return;
  if (!/^https:\/\/(?:www\.)?velven\.com\.au$/.test(root.location.origin)) return;
  // No tracking on sensitive/free-text surfaces, including cart notes and contact pages.
  if (/\/(account|search|contact|checkouts?|orders)(\/|$)/i.test(root.location.pathname)) return;
  function cookie(name) { return ('; ' + (doc.cookie || '')).indexOf('; ' + name + '=1') >= 0; }
  function internal() {
    var role = root.Shopify && root.Shopify.theme && root.Shopify.theme.role;
    // Shopify can remove preview_theme_id from the address bar after setting its preview cookie.
    return cookie('velven_analytics_internal') || !!(root.Shopify && root.Shopify.designMode) ||
      !!(role && String(role).toLowerCase() !== 'main') || /[?&]preview_theme_id=/.test(root.location.search || '');
  }
  if (internal()) return;
  var sdk = null, loading = false, started = false, generation = 0, revoked = false, deniedByEvent = false;
  var pending = [], kickLoad = null, metrics = null;
  var paintTiming = {}; // Local diagnostic numbers only; never sent as event properties.
  var acquisition = {}; // Only sanitized, consent-permitted session context is persisted.
  function acquisitionContext() {
    try {
      var stored = root.sessionStorage.getItem('velven-ph-acquisition');
      var saved = stored ? JSON.parse(stored) : null;
      if (saved && Date.now() - saved.at < 1800000) {
        var checked = clean('page_viewed', saved.properties, null);
        ['traffic_source', 'traffic_medium', 'campaign_id', 'adset_id', 'ad_id'].forEach(function (k) { if (checked[k]) acquisition[k] = checked[k]; });
      }
      var incoming = attribution(root.location.search || '', null, doc.referrer || '');
      if (!Object.keys(acquisition).length) acquisition = incoming;
      root.sessionStorage.setItem('velven-ph-acquisition', JSON.stringify({ at: Date.now(), properties: acquisition }));
    } catch (_) { acquisition = attribution(root.location.search || '', null, doc.referrer || ''); }
  }
  var session = { count: 0, seen: 0, landing: false };
  try {
    var saved = JSON.parse(root.sessionStorage.getItem('velven-ph-budget'));
    if (saved && Date.now() - saved.seen < 1800000) session = saved;
  } catch (_) {}
  function saveBudget() {
    session.seen = Date.now();
    try {
      root.sessionStorage.setItem('velven-ph-budget', JSON.stringify(session));
      root.sessionStorage.setItem('velven-ph-acquisition', JSON.stringify({ at: Date.now(), properties: acquisition }));
    } catch (_) {}
  }
  var family = ENUMS.page_family.indexOf(config.page_family) >= 0 ? config.page_family : 'other';
  function allowed() {
    if (deniedByEvent || internal()) return false;
    try { return root.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  var identityWrites = Promise.resolve();
  function checkoutIdentity() {
    if (!started || revoked || !allowed() || !sdk || typeof sdk.get_distinct_id !== 'function') return '';
    var id = sdk.get_distinct_id();
    return typeof id === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[47][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(id) ? id : '';
  }
  function syncCheckoutIdentity() {
    identityWrites = identityWrites.then(function () {
      if (typeof root.fetch !== 'function') return;
      var route = root.Shopify && root.Shopify.routes && root.Shopify.routes.root || '/';
      // Read-only first: write only when the cart's stored ID differs. No consent and nothing stored means no cart/update.js call.
      return root.fetch(route + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (response) {
        return response && response.json ? response.json() : null;
      }).then(function (cart) {
        // Recompute after the read: consent may have been withdrawn while cart.js was pending.
        var wanted = checkoutIdentity();
        var stored = cart && cart.attributes && cart.attributes.velven_posthog_anonymous_id || '';
        if (!cart || stored === wanted) return;
        return root.fetch(route + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { velven_posthog_anonymous_id: wanted } })
        });
      });
    }).catch(function () {});
    return identityWrites;
  }
  function send(name, props, at) {
    if (!sdk || revoked || !allowed() || session.count >= 40) return;
    try {
      sdk.capture(name, props, { timestamp: new Date(at) });
      if (name === 'landing_viewed') { session.landing = true; saveBudget(); }
    } catch (_) {} // telemetry never breaks cart/calculator UX
  }
  function capture(name, input) {
    if (revoked || !allowed() || session.count + pending.length >= 40) return;
    var props = clean(name, Object.assign({ page_family: family }, acquisition, input), null);
    if (!props) return;
    var at = Date.now();
    // Memory only, allowed events only. Withdrawal discards this boot queue; no denied backfill.
    if (!sdk || !started) pending.push({ name: name, props: props, at: at });
    else send(name, props, at);
  }
  function publicURL() {
    var handle = config.product_handle || config.page_handle;
    var prefix = { product: 'products', collection: 'collections', page: 'pages' }[family];
    var path = prefix && typeof handle === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle) && handle.length < 120 ? prefix + '/' + handle : family === 'index' ? '' : family;
    return root.location.origin + '/' + path;
  }
  function begin() {
    if (!allowed() || loading || started) return;
    loading = true;
    acquisitionContext();
    if (!metrics) metrics = pageMetrics(doc, root, allowed);
    var ticket = ++generation;
    // Official queue bootstrap, kept private to this integration until the SDK loads.
    if (root.posthog) { loading = false; return; }
    var ph = root.posthog = [];
    if (!session.landing) capture('landing_viewed', { device_class: root.innerWidth < 768 ? 'mobile' : 'desktop' });
    capture('page_viewed');
    if (config.product_handle) capture('product_viewed', { product_handle: config.product_handle, product_kind: /sample/.test(config.product_handle) ? 'sample' : 'unknown' });
    ph._i = [];
    ph.__SV = 1;
    ['capture', 'opt_in_capturing', 'opt_out_capturing', 'stopSessionRecording'].forEach(function (method) {
      ph[method] = function () { ph.push([method].concat(Array.prototype.slice.call(arguments))); };
    });
    ph.init = function (key, options) { ph._i.push([key, options, 'posthog']); };
    ph.init(config.key, {
      api_host: config.host, ui_host: 'https://eu.posthog.com',
      person_profiles: 'never', persistence: 'sessionStorage',
      save_campaign_params: false, save_referrer: false, opt_out_useragent_filter: false,
      autocapture: false, capture_pageview: true, capture_pageleave: true,
      // Heatmaps own click/movement/rage detection; generic DOM autocapture is unnecessary.
      capture_dead_clicks: true, rageclick: true, capture_heatmaps: true,
      capture_performance: { web_vitals: true, web_vitals_allowed_metrics: ['LCP', 'INP', 'CLS'] },
      disable_capture_url_hashes: true, enable_recording_network: false,
      capture_exceptions: false, enable_recording_console_log: false,
      advanced_disable_feature_flags: true, disable_surveys: true,
      session_recording: {
        // Public store text/images are readable; typed inputs and private regions stay protected.
        maskAllInputs: true, maskTextSelector: null, maskAllElementAttributes: false,
        sampleRate: 1.0,
        blockSelector: 'input, textarea, select, [contenteditable], form, iframe, [data-private], .ph-no-capture, [data-cart-note], [data-customer], [data-split-state]',
        maskAttributeFn: function (name, value) {
          if (/^(data-|_)/i.test(name)) return '';
          return /^(?:xlink:)?href$/i.test(name) ? value.split(/[?#]/)[0] : value;
        },
        maskCapturedNetworkRequestFn: function (request) {
          if (Object.keys(request).length !== 1 || typeof request.name !== 'string') return null;
          return { name: publicURL() };
        },
        recordCrossOriginIframes: false,
        recordHeaders: false, recordBody: false,
        recordCanvas: false, collectFonts: false, slimDOMOptions: true,
        inlineStylesheet: true, inlineStylesheetBudgetRules: 250
      },
      before_send: function (event) {
        if (revoked || !allowed() || !event) return null;
        // Discard automatic person mutation/enrichment envelopes as well as unsafe properties.
        event = { event: event.event, properties: event.properties || {}, uuid: event.uuid, timestamp: event.timestamp };
        if (event.event === '$snapshot') {
          // Recorder masks DOM and navigation URLs at source; strip automatic envelope context too.
          var replay = { token: config.key, $process_person_profile: false };
          ['$snapshot_data', '$snapshot_bytes', '$session_id', '$window_id', 'distinct_id'].forEach(function (k) {
            if (event.properties[k] !== undefined) replay[k] = event.properties[k];
          });
          if (cookie('velven_analytics_verification')) replay.is_test = true;
          event.properties = replay;
          return event;
        }
        if (session.count >= 40) return null;
        var native = nativeProperties(event.event, event.properties, publicURL());
        if (event.event === '$pageleave' && native && metrics) Object.assign(native, metrics());
        var safe = native ? Object.assign(clean('page_viewed', Object.assign({ page_family: family }, acquisition), null), native) : clean(event.event, Object.assign({}, event.properties, acquisition), null);
        if (!safe) return null;
        session.count += 1; saveBudget();
        safe.token = config.key;
        safe.$process_person_profile = false;
        if (cookie('velven_analytics_verification')) safe.is_test = true;
        // Preserve pseudonymous routing only; no automatic referrer, title, URL or campaign values.
        ['$session_id', '$window_id', 'distinct_id', '$device_id', '$pageview_id', '$prev_pageview_id'].forEach(function (k) {
          if (typeof event.properties[k] === 'string') safe[k] = event.properties[k];
        });
        event.properties = safe;
        return event;
      },
      loaded: function (instance) {
        loading = false;
        sdk = instance;
        if (ticket !== generation || !allowed()) { pending = []; sdk.opt_out_capturing(); sdk.stopSessionRecording(); return; }
        sdk.opt_in_capturing({ captureEventName: false });
        started = true;
        syncCheckoutIdentity();
        var boot = pending; pending = [];
        boot.forEach(function (item) { send(item.name, item.props, item.at); });
        startExposures();
      }
    });
    var script = doc.createElement('script');
    script.async = true;
    script.src = 'https://eu-assets.i.posthog.com/static/array.js';
    script.fetchPriority = 'low';
    var appended = false, armed = false, interactionSeen = false, hardTimer, observer;
    function append(reason) {
      if (appended || ticket !== generation || !allowed()) return;
      appended = true;
      root.clearTimeout(hardTimer);
      if (observer) observer.disconnect();
      paintTiming.boot_reason = reason;
      if (root.performance) paintTiming.sdk_request_ms = root.performance.now();
      doc.head.appendChild(script);
    }
    function idle() {
      if (armed) return;
      armed = true;
      if (!root.requestAnimationFrame) { append('no-animation-frame'); return; }
      // Separate queries are intentional: a selector union would pick an earlier header/logo.
      var gallery = doc.querySelector && (doc.querySelector('.vmcm-gal__slide:first-child .vmcm-gal__img') || doc.querySelector('.vmcm-gal__img'));
      var hero = gallery || (doc.querySelector && (doc.querySelector('main img[fetchpriority="high"]') || doc.querySelector('main img')));
      var productGallery = family === 'product' && !!gallery;
      var scheduled = false;
      function painted(reason) {
        if (scheduled || appended) return;
        scheduled = true;
        root.requestAnimationFrame(function () { root.requestAnimationFrame(function () {
          function ready() {
            if (interactionSeen) append('interaction');
            else if (root.requestIdleCallback) root.requestIdleCallback(function () { append(reason); }, { timeout: 1000 });
            else append(reason);
          }
          if (productGallery || interactionSeen) ready(); else root.setTimeout(ready, 2000);
        }); });
      }
      function decoded() {
        try {
          if (hero && hero.decode) hero.decode().then(function () { painted('image-decoded'); }, function () { append('decode-error'); });
          else painted('render-frames');
        } catch (_) { append('decode-error'); }
      }
      if (hero && hero.addEventListener) {
        hero.addEventListener('load', decoded, { once: true });
        hero.addEventListener('error', function () { append('image-error'); }, { once: true });
      }
      if (hero && hero.complete && hero.naturalWidth === 0) { append('image-error'); return; }
      if (productGallery && root.PerformanceObserver && (root.PerformanceObserver.supportedEntryTypes || []).indexOf('largest-contentful-paint') >= 0) {
        paintTiming.gate = 'gallery-lcp';
        observer = new root.PerformanceObserver(function (list) {
          list.getEntries().forEach(function (entry) {
            if (entry.element === gallery || (entry.url && entry.url === (gallery.currentSrc || gallery.src))) {
              paintTiming.hero_paint_ms = entry.startTime;
              observer.disconnect();
              painted('gallery-lcp');
            }
          });
        });
        try { observer.observe({ type: 'largest-contentful-paint', buffered: true }); }
        catch (_) { decoded(); }
      } else if (!hero || hero.complete) decoded();
    }
    // A particular image may never become LCP, decode may hang, or frames/idle may stall.
    // The approved five-second post-load ceiling and first interaction bypass those waits.
    kickLoad = function () { interactionSeen = true; append('interaction'); };
    function loadedPage() {
      if (appended || ticket !== generation || !allowed()) return;
      if (root.performance) paintTiming.load_ms = root.performance.now();
      hardTimer = root.setTimeout(function () { append('load-timeout'); }, 5000);
      idle();
    }
    if (doc.readyState !== 'complete' && root.addEventListener) root.addEventListener('load', loadedPage, { once: true }); else loadedPage();
  }
  function consentChanged(event) {
    if (event && event.detail && typeof event.detail.analyticsAllowed === 'boolean') deniedByEvent = !event.detail.analyticsAllowed;
    if (!allowed()) {
      generation += 1;
      acquisition = {};
      pending = [];
      try { root.sessionStorage.removeItem('velven-ph-acquisition'); } catch (_) {}
      if (sdk) { revoked = true; sdk.stopSessionRecording(); sdk.opt_out_capturing(); }
      syncCheckoutIdentity();
      return;
    }
    // Reload after a revoke/regrant; never replay events from the denied interval.
    if (!started) begin();
  }
  root.VelvenPostHog = { capture: capture, timing: paintTiming };
  function firstInteraction() {
    if (!allowed() || paintTiming.first_interaction_ms !== undefined) return;
    paintTiming.first_interaction_ms = root.performance ? root.performance.now() : Date.now();
    paintTiming.replay_active_at_first_interaction = !!(sdk && typeof sdk.sessionRecordingStarted === 'function' && sdk.sessionRecordingStarted());
    if (kickLoad) kickLoad();
  }
  ['pointerdown', 'touchstart', 'wheel', 'keydown', 'click'].forEach(function (name) {
    // Do not consume the listener on an unconsented interaction.
    doc.addEventListener(name, firstInteraction, { capture: true, passive: true });
  });
  // Visible choice works in AU too; update Analytics only, never marketing permission.
  ['off', 'on'].forEach(function (choice) {
    var button = doc.querySelector && doc.querySelector('[data-velven-analytics="' + choice + '"]');
    if (button) button.addEventListener('click', function () {
      var privacy = root.Shopify && root.Shopify.customerPrivacy;
      if (privacy && privacy.setTrackingConsent) privacy.setTrackingConsent({ analytics: choice === 'on' }, function () {
        syncCheckoutIdentity().then(function () { root.location.reload(); });
      });
    });
  });
  doc.addEventListener('visitorConsentCollected', consentChanged);
  doc.addEventListener('formdata', function (event) {
    if (event.target && event.target.id === 'vmcm-cart-form') event.formData.set('attributes[velven_posthog_anonymous_id]', checkoutIdentity());
  });
  doc.addEventListener('cart:refresh', syncCheckoutIdentity);
  doc.addEventListener('velven:calculator-event', function (event) {
    var d = event.detail || {}, p = d.properties || {};
    if (d.name === 'calculator_validated') return;
    capture(d.name, { product_handle: p.product_handle, placement: p.placement,
      width: p.roll_width_cm, previous_width: p.previous_width,
      field_category: p.field_category, metres_bucket: bucket(p.recommended_metres),
      quantity_bucket: bucket(p.selected_metres), orientation: p.orientation });
  });
  doc.addEventListener('velven:cart-success', function (event) {
    var items = event.detail && event.detail.items || [];
    // One event per successful mutation (not per cart refresh or calculator notification).
    var kinds = [], width;
    items.forEach(function (item) {
      var title = String(item.variant_title || '');
      var kind = /sample/i.test(title + ' ' + item.product_title) ? 'sample' : /60|120/.test(title) ? 'roll' : 'tool';
      if (kinds.indexOf(kind) < 0) kinds.push(kind);
      if (/120/.test(title)) width = '120'; else if (/60/.test(title)) width = '60';
    });
    capture('product_added_to_cart', { product_kind: kinds.length > 1 ? 'mixed' : kinds[0] || 'unknown', width: width,
      quantity_bucket: bucket(items.reduce(function (n, item) { return n + Number(item.quantity || 0); }, 0)) });
  });
  // Bounded autocapture: only explicitly reviewed public controls, never arbitrary DOM text/attributes.
  doc.addEventListener('click', function (event) {
    var social = event.target.closest && event.target.closest('a.vmcm-footer__soclink');
    if (social) {
      try {
        var host = new URL(social.href).hostname.toLowerCase();
        var platform = /^(www\.)?instagram\.com$/.test(host) ? 'instagram' : /^(www\.)?facebook\.com$/.test(host) ? 'facebook' : null;
        if (platform) capture('social_profile_clicked', { social_platform: platform });
      } catch (_) {}
    }
    var el = event.target.closest && event.target.closest('[data-posthog-control]');
    if (!el || el.closest('form, [data-private], [contenteditable]')) return;
    var control = el.getAttribute('data-posthog-control');
    capture('ui_interacted', { control: control });
    if (control === 'sample') capture('sample_cta_clicked', { placement: 'sample_offer' });
  });
  function startExposures() {
    if (!root.IntersectionObserver) return;
    var observer = new root.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        root.clearTimeout(el.__phExposure);
        if (entry.intersectionRatio >= 0.5 && allowed()) el.__phExposure = root.setTimeout(function () {
          if (allowed()) { capture('sample_offer_viewed', { placement: 'sample_offer' }); observer.unobserve(el); }
        }, 1000);
      });
    }, { threshold: [0, 0.5] });
    doc.querySelectorAll('[data-posthog-control="sample"]').forEach(function (el) { observer.observe(el); });
  }
  if (root.Shopify && root.Shopify.loadFeatures) root.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) begin(); });
  syncCheckoutIdentity();
  begin();
})(typeof window === 'object' ? window : globalThis);
